"use strict";
var traveler_detail_component_1 = require("./traveler-detail.component");
exports.TravelerDetailComponent = traveler_detail_component_1.TravelerDetailComponent;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/traveler-details/index.js